// extracted by mini-css-extract-plugin
export default {"productsContainer":"f5JBR","product":"FhFDr","productsList":"lKA3u"};